// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'streu_en',
  de = 'streu_de',
  fr = 'streu_fr',
  es = 'streu_es',
}
